export default __webpack_public_path__ + "static/media/react.9803f0e6.svg";